module.exports = __webpack_public_path__ + "img/instagram.77fb297a.png";